import requests from "./httpService";

const TaskServices = { 
  getAllTask: async () => {
    return requests.get("/task/all");
  }, 
 
  getTaskById: async (id) => {
    return requests.get(`/task/${id}`); 
  },
 
  addTask: async (body) => {
    return requests.post("/task/add", body);
  },

  updateTask: async (id, body) => {
    return requests.put(`/task/${id}`, body);
  }, 

  deleteTask: async (id, body) => {
    return requests.delete(`/task/${id}`, body);
  },  

};

export default TaskServices; 
